<template>
  <a v-if="notExpired" :href="link" target="_blank" class="mx-2 text-center cursor-pointer py-2 px-4 bg-red-100 text-red-800 rounded-full hover:bg-red-200 hover:text-red-900 focus:outline-none focus:shadow-outline focus:text-red-500" aria-label="Notifications">
    <div v-if="actionText" class="text-xs mb-1">{{ actionText }}</div>
    <div class="text-base font-bold">{{ primaryText}}</div>
  </a>
</template>

<script>
  export default {
    name: 'PromotionLinkButton',
    props: {
      expiryDate: {
        type : String,
        required: true
      },
      primaryText : String,
      actionText : String,
      link: String
    },

    computed: {
      notExpired()  {
        return new Date() < new Date(this.expiryDate);
      }
    }
  }
</script>
